import { MyAccountModel } from "../models/MyAccount";
import { ActiveDeActivePayload } from "../models/User";
import API from "./api";

export const PutUserDetails = (configUrl: string, payload: MyAccountModel) =>
  API.putApi(`${configUrl}api/Admin/UpdateUserDetails`, payload);

export const GetResetPassword = (baseUrl: string, payload: string) => 
  API.postApi(`${baseUrl}api/Admin/resetPassword?emailId=${payload}`);
  
export const GetResendRegistration = (baseUrl: string, payload: string) =>
  API.postApi(`${baseUrl}api/Admin/resendRegistration?emailId=${payload}`);

export const GetActivateDeactivateUser = (baseUrl: string, payload: ActiveDeActivePayload) =>
  API.postApi(`${baseUrl}api/Admin/activateDeactivateUserAccount`, payload);